import React from 'react';
import { r } from '../../../../routes';
import { Loading } from './Loading';

interface Props {
  customerId: string;
}

export const TrackingPageThankyouRedirect: React.FC<Props> = ({ customerId }) => {
  React.useEffect(() => {
    window.location.assign(r.external.trackingPageThankyou({ customer_id: customerId }));
  }, []);

  return <Loading />;
};
